import { add, compareAsc, format, parseISO } from "date-fns";

export const getFormattedDate = (
  date: string | null | undefined
): Date | null => {
  if (typeof date !== "string") {
    return null;
  }

  return new Date(date);
};

export const getFormattedDateISO = (date: string, pattern: string) => {
  return format(parseISO(date.toString()), pattern);
};

export const generateMonths = (startDate: Date, endDate: Date): Date[] => {
  let start = new Date(startDate);
  const result = [];

  while (compareAsc(start.setHours(0), endDate.setHours(0)) < 1) {
    result.push(start);
    start = add(start, { months: 1 });
  }

  return result;
};
